export const JURY_SPECIAL_MENTIONS = [
  {
    id: "jury-special-mention-1",
    name: "Abhishek Sharma",
    "entity-type": "person",
    designation: "Cricketer",
    company: "N/A",
    age: "25",
    slug: "abhishek-sharma",
    photo: [{ key: "fortune-india/2026-08-19/znmf7g84/Abhishek-Sharma" }],
  },
  {
    id: "jury-special-mention-2",
    name: "Alia Bhatt",
    "entity-type": "person",
    designation: "Founder",
    company: "Ed-a-Mamma",
    age: "33",
    slug: "alia-bhatt",
    photo: [{ key: "fortune-india/2026-08-19/mmw3dws5/Alia-Bhatt"}],
  },
  {
    id: "jury-special-mention-3",
    name: "Arijit Singh",
    "entity-type": "person",
    designation: "Singer & Musician",
    company: "N/A",
    age: "39",
    slug: "arijit-singh",
    photo: [{ key: "fortune-india/2026-08-19/nl2gb59a/Arijit-Singh"}],
  },
  {
    id: "jury-special-mention-4",
    name: "Azeez Gupta, Namya Mahajan, Siddhant Sachdeva & Utsav Kheria",
    "entity-type": "person",
    designation: "Co-founders",
    company: "Rocket Learning",
    age: "36, 33, 33, 39",
    slug: "azeez-gupta-namya-mahajan-siddhant-sachdeva-utsav-kheria",
    photo: [{ key: "fortune-india/2026-08-19/to9vepns/Azeez-Gupta"}],
  },
  {
    id: "jury-special-mention-5",
    name: "Raj Shamani",
    "entity-type": "person",
    designation: "Podcaster",
    company: "N/A",
    age: "30",
    slug: "raj-shamani",
    photo: [{ key: "fortune-india/2026-08-19/iodkyuis/Raj-Shamani"}],
  },
  {
    id: "jury-special-mention-6",
    name: "Vaibhav Sooryavanshi",
    "entity-type": "person",
    designation: "Cricketer",
    company: "N/A",
    age: "15",
    slug: "vaibhav-sooryavanshi",
    photo: [{ key: "fortune-india/2026-08-19/sfyp40ro/Vaibhav-Sooryavanshi"}],
  },
];
